import React, { useMemo } from "react";
import LinearProgress from '@material-ui/core/LinearProgress';
import { withStyles } from "@material-ui/styles";
import { useSelector } from "react-redux";

const BorderLinearProgress = withStyles((theme) => ({
    root: {
        height: 10,
        borderRadius: 5,
    },
    colorPrimary: {
        backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
    },
    bar: {
        borderRadius: 5,
        backgroundColor: '#1a90ff',
    },
}))(LinearProgress);

export default () => {
    const { syncGroups } = useSelector(({ Groups }) => Groups);

    return useMemo(() => {
        return (
            syncGroups.totalAccount ? <div style={{
                width: "92%",
                backgroundColor: "#ffffff",
                position: "absolute",
                zIndex: 100,
                top: 5,
                left: "4%",
                borderRadius: 5,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                gap: 10,
                padding: 5,
                border: "1px solid #ddd"
            }}>
                <div style={{
                    textAlign: "center"
                }}>
                    Đang đồng bộ nhóm của {syncGroups.indexAccount + 1}/{syncGroups.totalAccount} (tài khoản)
                </div>
                <div style={{
                    textAlign: "center"
                }}>
                    Đang đồng bộ "{syncGroups.uuid}"
                </div>
                <div>
                    <BorderLinearProgress variant="determinate" value={Math.floor((syncGroups.indexGroup / syncGroups.totalGroup) * 100) || 0} style={{ width: "98%", marginLeft: "1%" }} />
                </div>
            </div> : <></>
        )
    }, [syncGroups])
}